/**
 * Aligns with mobile purchase tab (cost for ordering, unit_price as MRP).
 * @see shwapno-mini/apps/mobile/src/app/(tabs)/purchase.jsx
 */
export function getPurchaseCatalogCostPrice(row) {
  if (!row) return 0
  const cost =
    row.unit_cost ??
    row.cost_price ??
    row.price ??
    row.unit_price
  const n = Number(cost)
  return Number.isFinite(n) ? n : 0
}

export function getPurchaseCatalogMrpPrice(row) {
  if (!row) return 0
  const cost = getPurchaseCatalogCostPrice(row)
  const mrp = row.unit_price != null ? Number(row.unit_price) : cost
  return Number.isFinite(mrp) ? mrp : cost
}
